import React, {useEffect, useRef} from 'react';
import Img from "gatsby-image";
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

import Button from '../../elements/button/button.component';
import GradButton from '../../elements/button/gradbutton.component';
import BgEl from '../../elements/misc/bg-el.component';



const Banner = ({noMargin, title, text, image, link1, link2}) => {
  const circle1 = useRef(null);
  const circle2 = useRef(null);
  const circle3 = useRef(null);
  const circle4 = useRef(null);
  const circle5 = useRef(null);

  const scrubValue = 0.8

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    if ( circle1 && circle2 && circle3 && circle4 && circle5) {
      gsap.to(circle3.current, {
        scrollTrigger: {
          trigger: circle3.current,
          scrub: scrubValue,
        },
        y: 40,
        x: 25,
      })
      gsap.to(circle1.current, {
        scrollTrigger: {
          trigger: circle1.current,
          scrub: scrubValue,
        },
        y: -40,
        x: 25,
      })
      gsap.to(circle2.current, {
        scrollTrigger: {
          trigger: circle2.current,
          scrub: scrubValue,
        },
        y: 60,
        x: -30,
      })
      gsap.to(circle4.current, {
        scrollTrigger: {
          trigger: circle4.current,
          scrub: scrubValue,
        },
        y: -80,
        x: -30,
      })
      gsap.to(circle5.current, {
        scrollTrigger: {
          trigger: circle5.current,
          scrub: scrubValue,
        },
        y: 80,
        x: 80,
      })
    }

  }, [  circle1, circle2, circle3, circle4, circle5 ])

  return (
    <div className={`bg-gradient-to-b from-primary-light to-primary-dark ${!noMargin && 'mb-10 md:mb-20 lg:mb-28' } overflow-hidden relative`}>
      <div ref={circle1} className="absolute -left-24 -top-24 select-none">
        <BgEl type="rectangle" colour="#705CA4" opacity="opacity-50" />
      </div>
      <div ref={circle2} className="hidden md:block absolute left-24 bottom-24 select-none">
        <BgEl type="circle" colour="#3F2E7F" />
      </div>
      <section className="flex flex-wrap items-center max-w-screen-xl mx-auto py-10 md:py-12 px-6 md:px-8">
        <div className="relative z-10 w-full md:w-1/3 lg:w-1/2 md:pr-8 lg:pr-12">
          {image && <Img className="w-full h-64 rounded-3xl  mb-5 md:mb-0" alt={image.alt} fluid={image.src} />}
        </div>
        <div className="relative w-full md:w-2/3 lg:w-1/2 md:pl-8">
          <div className="max-w-sm relative z-10 text-center">
            {title && <h2 className="text-3xl md:text-4xl text-white-default font-semibold mb-4">{title}</h2>}
            {text && <p className="mb-5 text-white-200">{text}</p>}
            <div className="flex flex-wrap items-center justify-center">
              {link1 && <div className="pr-4 md:mb-0"><GradButton {...link1} /></div>}
              {link2 && <Button {...link2} />}
            </div>
          </div>
          <div ref={circle3} className="absolute -top-8 -left-6 select-none">
            <BgEl type="circle" colour="#705CA4" />
          </div>
          <div ref={circle4} className="absolute -right-64 md:-right-96 -top-64 md:-top-24 select-none">
            <BgEl type="rectangle" colour="#705CA4" opacity="opacity-50" />
          </div>
          <div ref={circle5} className="absolute right-0 md:-right-24 -bottom-5 md:-bottom-10 select-none">
            <BgEl type="circle" colour="#3F2E7F" />
          </div>
        </div>
      </section>
    </div>
  )
}

export default Banner;